// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SQIRp","left":"styles_left__3SqJ3"};